import { render, staticRenderFns } from "./studio.vue?vue&type=template&id=3690cf06"
import script from "./studio.vue?vue&type=script&lang=js"
export * from "./studio.vue?vue&type=script&lang=js"
import style0 from "./studio.vue?vue&type=style&index=0&id=3690cf06&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports